import { type ComponentProps } from 'react';

import { TranslateHtml } from '@change-corgi/core/react/i18n';
import { Avatar } from '@change-corgi/design-system/components/media';
import { Box, Flex } from '@change-corgi/design-system/layout';
import { Text } from '@change-corgi/design-system/typography';

import type { ShareFeedItem as ShareFeedItemType } from 'src/app/pages/psf/share/pageContext';

import { useShareFeedItem } from './hooks/useShareFeedItem';

type Props = {
	item: ShareFeedItemType;
};

export const ITEM_MIN_HEIGHT = 80;

export function ShareFeedItem({ item, ...rest }: Props & ComponentProps<typeof Flex>) {
	const {
		data: { channelName },
	} = useShareFeedItem(item.channel);

	return (
		<Flex
			sx={{ justifyContent: 'center', alignItems: 'center', minHeight: ITEM_MIN_HEIGHT }}
			data-qa="share-feed-item"
			{...rest}
		>
			<Flex p={8} mr={8}>
				<Avatar src={item.userPhoto || undefined} variant="subtle" alt="" />
			</Flex>
			<Box sx={{ flex: 1 }}>
				<Text as="div" breakWord>
					<TranslateHtml
						value="fe.components.psf.share.share_feed.share_activity_text_line_1"
						replacements={{
							sharer_name: item.userDisplayName,
							medium: channelName,
						}}
					/>
				</Text>
				<Text as="div" size="caption">
					{item.createdAtRelativeLocalized}
				</Text>
			</Box>
		</Flex>
	);
}
